//TODO: when (if) dictionaries endpoint is added dictionary type should be defined in api contract

export enum DictionaryType {
  USERS = 'USERS',
}
